import { CommonService } from './../base-services/common.service';
import { FormControl, NG_VALIDATORS } from "@angular/forms";

  export function ytKontrolaPoModulu97(value : string):string
  {
      if (value == null)
        return null;
    
      return kotrolaPoModulu97(value);   
  } 

function kotrolaPoModulu97(niz : string):string{
    let slova: string[];
      let vrednosti: string[];
    
      slova = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", 
      "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", 
      "U", "V", "W", "X", "Y", "Z"];
    
      vrednosti = ["10", "11", "12", "13", "14", "15", "16", "17", "18", "19",
      "20", "21", "22", "23", "24", "25", "26", "27", "28", "29",
      "30", "31", "32", "33", "34", "35"];
    
      let vratiVrednost: string = "";
      let karakter: string = "";
      let nizbrojeva: string = niz;

      for (let i : number = 0; i < nizbrojeva.length; i++)
      {
        karakter=nizbrojeva.substr(i,1);
        if (karakter.toLowerCase().match(/[a-z]/i)){
          for (let j : number = 0; j<slova.length; j++){
            if (slova[j] == karakter){
              vratiVrednost = vrednosti [j];
              switch(i) {
                case 0:
                  nizbrojeva = vratiVrednost + nizbrojeva.substr(i+1,nizbrojeva.length);
                case nizbrojeva.length:
                  nizbrojeva.substr(i-1,nizbrojeva.length-1) + vratiVrednost;
                default :
                  nizbrojeva = nizbrojeva.substr(0,i) + vratiVrednost + nizbrojeva.substr(i+1,nizbrojeva.length);                  
              }
              break;
            }
          }
          i = 0;
        }
      }
      
      nizbrojeva = nizbrojeva + "00";
      let kontbr97 : number;

      kontbr97=Number("0."+podeli(nizbrojeva,"97").split(".")[1]);
      let vrati: string = new CommonService().PadLeft((98 - Math.round(kontbr97 * 97)).toString(), "0", 2); 
      return vrati;
  }

  function podeli(nizbrojeva : string, pdelilac : string):string{
    let delilac : number = Number(pdelilac);
    let ceoDeo : number = 0;
    let c : string = "";
    let zaDeliti : number = 0;
    let rezultat : string = "";
    let prilepi : string = "";
    let turenZarez : boolean = false;
    let pocetak : boolean = true;
    let b : number;
    for (let i : number = 0; i <= 39; i++){
      if (turenZarez)
        c = c + "0";
      else{
        prilepi = "";
        if (i < nizbrojeva.length)
          prilepi = nizbrojeva.substr(i,1);
        
        if (prilepi == ""){
          prilepi = "0";
          rezultat = rezultat + ".";
          turenZarez = true;
        }
        c = c + prilepi;
      }
      zaDeliti = Number(c);
      b = (zaDeliti / delilac);
      if((pocetak && Math.floor(b) > 0) || !pocetak){
        ceoDeo = Math.floor(b);
        rezultat = rezultat + ceoDeo.toString();
        c = (zaDeliti - ceoDeo * delilac).toString();
        pocetak = false;
      }
    }
    return rezultat;
  }

